export default [
  {
    description: 'Configuração',
    path: '/ged/configuracao',
    name: 'ged-configuracao',
    component: () => import('@/views/ged/gedconfiguracao/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Configuração',
    parent: 'ged-configuracao',
    path: '/ged/configuracao/cadastro/:id?',
    name: 'ged-configuracao-create',
    component: () => import('@/views/ged/gedconfiguracao/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
];
